import { ApiClient, createApi, type AuthStorage } from '@restaurant/api-client';
import { isTauri } from './platform';

export const API_URL = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') || window.location.origin;

let accessToken: string | null = null;

/**
 * Browser: access token in memory only; refresh token in an httpOnly cookie (never readable by JS).
 * Tauri: no shared cookie jar across origins, so it runs in "native" mode and keeps the refresh token
 * in the app-private webview storage.
 */
const storage: AuthStorage = {
  getAccessToken: () => accessToken,
  setAccessToken: (t) => {
    accessToken = t;
  },
  ...(isTauri
    ? {
        getRefreshToken: async () => localStorage.getItem('rt'),
        setRefreshToken: async (t: string | null) => (t ? localStorage.setItem('rt', t) : localStorage.removeItem('rt')),
      }
    : {}),
};

const authFailureListeners = new Set<() => void>();
export const onAuthFailure = (fn: () => void) => {
  authFailureListeners.add(fn);
  return () => {
    authFailureListeners.delete(fn);
  };
};

export const client = new ApiClient({
  baseUrl: API_URL,
  mode: isTauri ? 'native' : 'cookie',
  storage,
  onAuthFailure: () => authFailureListeners.forEach((fn) => fn()),
});
export const api = createApi(client);
export const getAccessToken = () => accessToken;
